import { http as axios } from 'utils/httpUtil';
import { baseApi } from 'utils/apiUtil';
import { LIFE_PICKER_KINDS } from 'modules/benefitsWellness/constants/BenefitConstants';
import { modifyAndEncodeBenefitClassNamesToHandleComma } from 'utils/commonUtil';

export const getLifeAndDisabilityPlanList = (
  employerId: string,
  planYearId: string,
  benefitClasses: string[]
) => {
  return axios.get(`${baseApi}/v1/plans/insurances`, {
    params: {
      'employer-id': employerId,
      'plan-year-id': planYearId,
      'benefit-kinds': LIFE_PICKER_KINDS.join(','),
      'benefit-classes':
        modifyAndEncodeBenefitClassNamesToHandleComma(benefitClasses).join(','),
    },
  });
};

export const getAllLifeAndDisabilityPlans = (
  employerId: string,
  planYearId: string,
  benefitKinds: string[],
  benefitClasses: string[]
) => {
  return axios.get(`${baseApi}/v1/plans/insurances`, {
    params: {
      'employer-id': employerId,
      'plan-year-id': planYearId,
      'benefit-kinds': benefitKinds.join(','),
      'benefit-classes':
        modifyAndEncodeBenefitClassNamesToHandleComma(benefitClasses).join(','),
    },
  });
};
